// extracted by mini-css-extract-plugin
module.exports = {"Label":"LabeledInfo_Label__20RG1"};